var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    property,
    listing_classes,
    listing_index,
    user_type
  } = options;

  let resource_id;

__p+='\n\n';

  // Set up classes for each of the listing cards (Show different number of cards at different breakpoints)
  switch(listing_index) {
    case 3:
      listing_classes = "visible-lg-inline-block";
      break;
    case 2:
      listing_classes = "hidden-sm col-xs-6 col-xxs-12";
      break;
    case 1:
      listing_classes = "col-xs-6 col-xxs-6";
      break;
    case 0:
      listing_classes = "col-xs-6 col-xxs-6";
      break;
    default:
      listing_classes = "";
  }

  // Hide any listings after the 4th one
  if (listing_index > 3) {
    listing_classes += " hide";
  }

__p+='\n\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' col-lg-3 col-md-4 col-sm-6 '+
((__t=( listing_classes ))==null?'':__t)+
' js-navigate-to" title="'+
((__t=( property.address_display ))==null?'':__t)+
'" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'">\n  <div class="listing-card-stacked">\n    <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-omtag="'+
((__t=( user_type ))==null?'':__t)+
'hp:new-listings:thumb" class="listing-link-overlay"> </a>\n    <div class="aspect-content">\n      <!-- Listing Photo-->\n      <div class="listing-photo">\n        ';
 if(property.photo_url){ 
__p+='\n        <img data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" alt="'+
((__t=( property.address_display ))==null?'':__t)+
'" src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="lazy-loaded">\n        ';
 } else { 
__p+='\n        <div class="coming-soon-img"></div>\n        ';
 } 
__p+='\n      </div>\n    </div> <!-- End of block of aspect-content -->\n    <div class="listing-cta">\n	  <div class="row js-tracking" data-status="'+
((__t=( property.status ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-source="MLS">\n      ';
 if (property.status !== 'ready_to_build') { 
__p+='\n        ';
 if ($.cookie('REMEMBER_ME')) { 
__p+='\n          ';
 resource_id = property.saved_resource_id 
__p+='\n            ';
 if (resource_id) { 
__p+='\n              <a class="btn btn-default removeFromSaved hp-unsave" data-res-id="'+
((__t=( resource_id ))==null?'':__t)+
'"><i class="ra ra-heart js-no-listing-click"></i></a>\n              <a class="btn btn-default addToSave hp-save" style="display:none"><i class="ra ra-heart-o js-no-listing-click"></i></a>\n            ';
 } else { 
__p+='\n              <a class="btn btn-default addToSave hp-save"><i class="ra ra-heart-o js-no-listing-click" data-omtag=\'hp:card:save-listing\'></i></a>\n              <a class="btn btn-default removeFromSaved hp-unsave" style="display:none"><i class="ra ra-heart js-no-listing-click"></i></a>\n            ';
 } 
__p+='\n        ';
 } else { 
__p+='\n          <a class="btn btn-default hp-save-not-logged-in" title="Save" href="#">\n          <i class="ra ra-heart-o '+
((__t=( "icon-space-right align-top" ))==null?'':__t)+
'" data-omtag=\'hp:card:save-listing\'></i><span></span></a>\n        ';
 } 
__p+='\n      ';
 } 
__p+='\n      </div>\n    </div>\n\n      <!-- Listing Information -->\n      <div class="listing-info">\n        <ul class="list-unstyled property-meta">\n          <li class="listing-info-price">\n            '+
((__t=( property.price_display ))==null?'':__t)+
'\n            <div class="listing-card-tags"></div>\n          </li>\n          ';
 if (property.address_display) { 
__p+='\n          <li class="listing-info-address ellipsis">'+
((__t=( property.address_display ))==null?'':__t)+
'</li>\n          ';
 } 
__p+='\n          <li class="listing-info-meta">\n            <ul class="list-horizontal list-style-slash">\n              ';
 if (property.beds) { 
__p+='\n              <li data-label="property-meta-beds"><span class="data-value">'+
((__t=( property.beds ))==null?'':__t)+
'</span> bd</li>\n              ';
 } 
__p+='\n              ';
 if (property.baths) { 
__p+='\n              <li data-label="property-meta-baths"><span class="data-value">'+
((__t=( property.baths ))==null?'':__t)+
'</span> ba</li>\n              ';
 } 
__p+='\n              ';
 if (property.sqft_display) { 
__p+='\n              <li class="hidden-xxs" data-label="property-meta-sqft"><span class="data-value">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sq ft</li>\n              ';
 } 
__p+='\n            </ul>\n          </li>\n        </ul>\n      </div>\n\n  </div> <!-- End of block of listing-card-filled -->\n</div> <!-- End of block of listing -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/newest_listings_listing_card.jst.ejs